export default __webpack_public_path__ + "static/media/WhiteEditIcon.c55d1cbb.svg";